import { ws_domain } from "../Links/Links";

export function baseWebsocket(setProductsDataInExplorer) {
    const socket = new WebSocket(ws_domain + '/ws/hiket/')
    socket.onopen = () => {
        console.log('hi')
    }

    socket.onclose = (e) => {
      console.log(e);
    }

    socket.onmessage = (e) => {
      const data = JSON.parse(e.data);
      setProductsDataInExplorer((currentData) => [data, ...currentData])

      console.log(data);
    }

}
